import { useState } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import BreakPoints from "../../BreakPoints";
import SideBar from "../../layout/SideBar";
import QuestionsMap from "../../components/QuestionManagement/QuestionsMap";
import SelectedQuestion from "../../components/QuestionManagement/SelectedQuestion";
import { useQuery } from "@tanstack/react-query";
import LoadingPage from "../LoadingPage";
import { useIsSelectedQuestion } from "../../Store/QuestionSlice";
import { useAuth } from "../../context/AuthContext";
import { authAxios } from "../../Axios/createAxios";
import { useIsVerified } from "../../context/UserContext";

export default function Posts() {
  const fetchUserQuestions = async () => {
    try {
      const { data } = await authAxios.get(`/users/user/questions`, { params: { cursor } });
      return data.data;
    } catch (e) {
      throw e;
    }
  };
  const { xSmall, small, medium, large, xLarge, xXLarge } = BreakPoints();
  const selectedQuestion = useIsSelectedQuestion();
  const { isAuth } = useAuth();
  const [cursor, setCursor] = useState(null);
  const isVerified = useIsVerified();
  const {
    data = {},
    isLoading,
    error,
  } = useQuery({
    queryKey: ["userQuestions", cursor], // تحديث البيانات عند تغيير الـ cursor
    queryFn: fetchUserQuestions,
    enabled: !!isVerified && !!isAuth,
    onSuccess: (data) => {
      console.log(data);
    },
    onError: () => {
      console.log(error);
    },
  });

  if (isLoading) return <LoadingPage />;
  return (
    <>
      {/* {isLoading && <LoadingPage />} */}
      <div className={`user-posts-page page-h ${selectedQuestion ? "selected" : ""}`} style={{ overflow: "hidden" }}>
        {(xLarge || xXLarge) && <Header />}
        {(large || medium) && <SideBar />}
        <article>
          {Object.keys(data?.data).length < 1 && (
            <h6 className="center absolute txt-center">You have no questions yet</h6>
          )}
          <QuestionsMap questions={data?.data} />
          <SelectedQuestion />
          <div className="d-flex">
            {data?.next_cursor && <button onClick={() => setCursor(data?.next_cursor)}>Next</button>}
            {data?.prev_cursor && <button onClick={() => setCursor(data?.prev_cursor)}>Prev</button>}
          </div>
        </article>
        {xXLarge || xLarge ? (
          <div
            className={`${xXLarge || xLarge ? "absolute d-grid center-y" : ""}`}
            style={{
              width: "calc(100% / 1.618)",
              right: 0,
              justifyContent: "center",
            }}>
            <span className="h3">select a question</span>
            <span>Choose from your existing questions </span>
          </div>
        ) : null}
        {(xSmall || small) && <Footer />}
      </div>
    </>
  );
}
